import { useAuth } from 'oidc-react';
import { useEffect} from 'react';
import { getBroadcastChannel } from '../utils/broadcastChannelUtil';
import {
  LOGOUT_BROADCAST_EVENT,
  ORIGINAL_PATH,
} from './../constants';
import { removeAuthCookie } from '../utils/authCookie';
import appConfigService from '../services/appConfigService';


const LogoutContainer: React.FC = () => {
  const { signOut } = useAuth();
  const broadcastChannel = getBroadcastChannel();

  useEffect(() => {
    const signOutFn = async () => {
      await signOut();
      broadcastChannel.postMessage(LOGOUT_BROADCAST_EVENT);
      removeAuthCookie();
      appConfigService.clearCache();
      const path: string | null = localStorage.getItem(ORIGINAL_PATH);
      localStorage.removeItem(ORIGINAL_PATH);
      window.location.href = path ?? '/';
    };
    signOutFn();
  }, [signOut, broadcastChannel]);
  return null;
};

export default LogoutContainer;